import React from "react";
export function PDFPrev(props) {
  // 👇️ 将 SVG 粘贴到组件中
  // 将 fill 和 stroke 颜色作为属性
  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "41",
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 20.5H13M13 20.5L20 27.5M13 20.5L20 13.5",
    stroke: props.stroke,
    strokeOpacity: "1.0",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}